import styled, { css } from "styled-components";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";
import { V2_INPUT_HEIGHT_PX } from "components/designV2/constants";

export const DesignV2AutocompleteContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const DesignV2FieldWrapper = styled.div<{
  $isFocused: boolean;
  $hasError: boolean;
}>`
  display: flex;
  align-items: center;
  gap: 8px;
  height: ${V2_INPUT_HEIGHT_PX}px;
  padding: 0 16px;
  border-radius: 16px;
  background-color: ${ColorV2.White};
  border: 1.5px solid ${ColorV2.Blue5};
  transition:
    border-color 0.2s ease,
    background-color 0.2s ease;

  ${(props) =>
    props.$isFocused &&
    css`
      border-color: ${ColorV2.Blue1};
    `}

  ${(props) =>
    props.$hasError &&
    css`
      border-color: ${ColorV2.NegativeRed};
    `}

  button {
    margin-top: 0;
  }
`;

export const DesignV2Input = styled.input<{ $isFocused: boolean }>`
  ${TypographyV2.b2}
  flex: 1 1 0;
  min-width: 0;
  border: none;
  background: transparent;
  outline: none;
  color: ${(props) => (props.$isFocused ? ColorV2.Blue1 : ColorV2.Blue5)};

  &::placeholder {
    color: ${(props) => (props.$isFocused ? ColorV2.Blue1 : ColorV2.Blue5)};
  }
`;

export const DesignV2ClearButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
`;

export const DesignV2SuggestionList = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  z-index: 20;
  border-radius: 16px;
  background-color: ${ColorV2.White};
  border: 1.5px solid ${ColorV2.Blue5};
  box-shadow: 0 12px 24px rgba(15, 42, 64, 0.12);
  padding: 8px 0;
  max-height: 260px;
  overflow-y: auto;
`;

export const DesignV2SuggestionItem = styled.button<{
  $isActive: boolean;
}>`
  ${TypographyV2.b2}
  width: calc(100% - 24px);
  margin: 0 12px;
  border: none;
  background: ${(props) => (props.$isActive ? ColorV2.Blue6 : "transparent")};
  color: ${ColorV2.Blue1};
  text-align: left;
  padding: 12px 16px;
  border-radius: 12px;
  cursor: pointer;

  &:hover {
    background: ${ColorV2.Blue6};
  }
`;

export const DesignV2LoadingRow = styled.div`
  ${TypographyV2.b2}
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${ColorV2.Blue4};
  padding: 12px 16px;
`;
